import { useNavigate } from 'react-router-dom';
import { displayName, ROLE_LABELS } from '../api/types';
import { useAuth, useMe } from '../auth/AuthContext';
import { Brand } from '../components/layout/Brand';
import { Badge, Button, Card, formatDate } from '../components/ui';

/**
 * What a deactivated account sees: its basic details and a way out. The API
 * refuses every other route for it, so there is nothing else to show.
 */
export function Deactivated() {
  const me = useMe();
  const { signOut } = useAuth();
  const navigate = useNavigate();

  const onSignOut = async () => {
    await signOut();
    navigate('/sign-in', { replace: true, state: { notice: 'You have been signed out.' } });
  };

  return (
    <div className="auth">
      <aside className="auth__side">
        <Brand to="/deactivated" light />
        <div className="auth__statement">
          <p className="eyebrow eyebrow--light">Balsam Solutions</p>
          <h2>This account has been deactivated.</h2>
          <p>
            You can still sign in and see your basic details, but the console and portal are closed
            to this account. If you believe this is a mistake, contact Balsam Solutions.
          </p>
        </div>
        <p className="auth__fineprint">Deactivated on {formatDate(me.user.deactivatedAt)}.</p>
      </aside>
      <div className="auth__panel">
        <div className="auth__card">
          <Card title="Your account" actions={<Badge tone="bad">deactivated</Badge>}>
            <dl className="kv">
              <dt>Name</dt>
              <dd>{displayName(me.user)}</dd>
              <dt>Email</dt>
              <dd>{me.user.email}</dd>
              <dt>Role</dt>
              <dd>{ROLE_LABELS[me.user.role]}</dd>
              <dt>Member since</dt>
              <dd>{formatDate(me.user.createdAt)}</dd>
            </dl>
            <p style={{ marginTop: '1.25rem', marginBottom: 0 }}>
              <Button variant="secondary" onClick={onSignOut}>
                Sign out
              </Button>
            </p>
          </Card>
        </div>
      </div>
    </div>
  );
}
